import React, { useState, useContext } from "react";
import "../../styles/pages/Banners/BannerManager.scss";
import BannerForms from "./BannerForms.js";
import NewBannerModal from "../../components/BannerManager/NewBannerModal";
import ValueContext from "../../ContextAPi/appContext";
import { useTranslation } from "react-i18next";

export default function BannerManager(props) {
  const appData = useContext(ValueContext);
  const { t } = useTranslation();
  const [showNewBanner, setShowNewBanner] = useState(false);
  const [bannerDetails, setBannerDetails] = useState({
    assetName: "",
    assetType: "",
    brandName: "",
    bannerLink: "",
    marketName: "",
    width: "",
    height: "",
    campaign: "",
    veevaDocNumber: "",
    reviewStatus: "",
    createdBy: "",
    createdOn: "",
    updatedBy: "",
    updatedDateTime: "",
    isAnimated: false,
    createdByName: "",
    updatedByName: "",
    createdDateTime: "",
    damDocNumber: "",
    sourceTemplateInfo: {
      assetName: "",
      brandName: "",
      campaign: "",
      marketName: "",
      createdBy: "",
      cratedByName: "",
      createdDateTime: "",
      updatedDateTime: "",
    },
    isBannerCreated: false,
    bannerCount: "",
  });
  const openNewBannerModal = (isRedirectFlag = false, genericInfo = {}) => {
    setShowNewBanner(!showNewBanner);
    if (isRedirectFlag === true) {
      appData.setFlagEditBanner(false);
      appData.setBannersEditCardData({
        cards: "",
      });
    }
  };
  return (
    <>
      <div className="banner-screen">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9 banner-manager">
              <div className="bannerTitleRow">
                <div className="bannerManagerTitle">
                  {t("bannerManager.bannerManager")}
                </div>
                <div
                  type="button"
                  className="newBanner"
                  onClick={openNewBannerModal}
                >
                  {t("bannerManager.newBanner")}
                </div>
              </div>
              {showNewBanner && (
                <NewBannerModal
                  openNewBannerModal={openNewBannerModal}
                  showNewBanner={showNewBanner}
                  bannerDetails={bannerDetails}
                  setBannerDetails={setBannerDetails}
                />
              )}
              <div>
                <BannerForms
                  bannerDetails={bannerDetails}
                  setBannerDetails={setBannerDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
